var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var ReactDOM = require('react-dom');
var Utils = require('./utils');
var Shopify = require('./shopify');
var HeaderPage = require('./header-page');
var ScrollToTop = require('./scroll-to-top');

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  componentDidMount: function() {

    document.title = "Contact Us - Ingledew's Shoes";

    this.scrollToTop('contact-page');

    jQuery(this.refs.form).validate({
      rules: {
        email: { required: true,
                 email: true },
      },
      submitHandler: function(form) {
        function clearForm(self) {
          jQuery(self.refs.name).val("");
          jQuery(self.refs.email).val("");
          jQuery(self.refs.comment).val("");
        }
        jQuery.post("/contact",
                { form_type: "contact",
                  utf8: "✓",
                  "contact[name]": jQuery(this.refs.name).val(),
                  "contact[email]": jQuery(this.refs.email).val(),
                  "contact[comment]": jQuery(this.refs.comment).val() },
                function(result) {
                  clearForm(this);
                  this.showThankYou();
                }.bind(this))          
        .error(function(e) {
          clearForm(this);
          this.showThankYou();
        }.bind(this));
      }.bind(this)
    })
  },

  showThankYou: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.formDiv)).fadeOut();
    jQuery(ReactDOM.findDOMNode(this.refs.thanks)).removeClass('hide');
    jQuery(ReactDOM.findDOMNode(this.refs.thanks)).fadeIn();
  },

  render: function() {
    return <main id="content" className="container" role="main">
            <div className="row">
                <div className="col-md-8 col-md-offset-2" ref="formDiv">
                    <p className="lead">{CMS.help.prefix}</p>
                    <h1>{CMS.help.title}</h1>
                    <p>{CMS.help.content}</p>
                    <form ref="form" id="contact-form">
                        <input type="text" placeholder="YOUR NAME" ref="name"></input>
                        <input type="text" name="email" placeholder="YOUR EMAIL*" ref="email" required email></input>
                        <textarea placeholder="COMMENT OR QUESTION*" ref="comment" required></textarea>
                        <div id="btn-wrap">
                            <input type="submit" value="SEND" className="btn btn-primary btn-wide"></input>
                        </div>
                    </form>
                </div>
                <div className="col-md-8 col-md-offset-2 hide" ref="thanks">
                    <h3>THANK YOU</h3>
                    <p>{CMS.help.thank}</p>
                    <Link className="btn btn-primary" to="/" >KEEP SHOPPING</Link>
                </div>
            </div>
        </main>
  }
})